import './Tariffs.css';
import api from '../api.js';
import { useEffect, useState } from "react";
import plus from "../imgs/plus.svg";
import edit from "../imgs/pen.svg";

export default function Tariffs() {
    const [tariffs, setTariffs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [newTariffName, setNewTariffName] = useState("");
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editedTariffName, setEditedTariffName] = useState("");
    const [originalTariffName, setOriginalTariffName] = useState("");

    const openEditModal = (tariff) => {
        setOriginalTariffName(tariff);
        setEditedTariffName(tariff);

        setError("");
        setMessage("");

        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setOriginalTariffName("");
        setEditedTariffName("");
        setError("");
        setMessage("");
    };


    useEffect(() => {
        document.title = "Тарифы - Wave";
        loadTariffs();
    }, []);

    async function loadTariffs() {
        try {
            const response = await api.get('/api/tariffs/get-all-tariffs');
            setTariffs(response.data);
        } catch (error) {
            setError("Ошибка загрузки тарифов");
        } finally {
            setLoading(false);
        }
    }

    const handleCreateTariff = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");
        setProcessing(true);

        try {
            const res = await api.post("/api/tariffs/create-tariff", {
                tariffName: newTariffName
            });

            if (res.status === 200) {
                setMessage("Тариф успешно создан");
                loadTariffs();
            }

            setNewTariffName("");
            setProcessing(false);
        } catch (err) {
            setError(
                err?.response?.data?.message || "Ошибка при создании тарифа"
            );
            setProcessing(false);
        }
    };

    const handleEditTariff = async (e) => {
        e.preventDefault();

        setProcessing(true);
        setError("");
        setMessage("");

        try {
            const res = await api.patch("/api/tariffs/edit-tariff", {
                tariffName: originalTariffName,
                newTariffName: editedTariffName
            });

            if (res.status === 200) {
                setMessage("Тариф успешно изменен");

                await loadTariffs();

                setOriginalTariffName(editedTariffName);
            }
        } catch (err) {
            setError(
                err?.response?.data || "Ошибка при редактировании"
            );
        } finally {
            setProcessing(false);
        }
    };


    const closeCreateModal = async () => {
        setIsCreateModalOpen(false);
        setNewTariffName("");
        setError('');
        setMessage('');
    }

    return (
        <div className="tariffs-main">
            <div className='tariffs-top'>
                <h1>Тарифы</h1>
                <button className='createTariff' onClick={() => setIsCreateModalOpen(true)}><p>Создать тариф</p><img src={plus} /></button>
            </div>
            {(
                <div className='tariffs-table-wrapper'>
                    <table className="tariffs-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Название тарифа</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="3">
                                        <span className="table-message">Загрузка...</span>
                                    </td>
                                </tr>
                            ) : error && tariffs.length === 0 ? (
                                <tr>
                                    <td colSpan="3">
                                        <span className="table-error">{error}</span>
                                    </td>
                                </tr>
                            ) : tariffs.length === 0 ? (
                                <tr>
                                    <td colSpan="3">
                                        <span className="table-message">
                                            Тарифы отсутствуют
                                        </span>
                                    </td>
                                </tr>
                            ) : (
                                tariffs.map((tariff, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{tariff}</td>
                                        <td>
                                            <button
                                                className='edit-btn'
                                                onClick={() => openEditModal(tariff)}
                                            >
                                                Редактировать
                                            </button>

                                            <button
                                                className="edit-btn-mobile"
                                                onClick={() => openEditModal(tariff)}
                                            >
                                                <img src={edit} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {isCreateModalOpen &&
                (
                    <div className="modalOverlay">
                        <div className="modalPartners">
                            <form onSubmit={handleCreateTariff}>
                                <div className='modalTop'>
                                    <h3>Создать новый тариф</h3>
                                    <button type="button" onClick={closeCreateModal}></button>
                                </div>
                                <input
                                    required
                                    type="text"
                                    placeholder='Название'
                                    value={newTariffName}
                                    onChange={(e) => setNewTariffName(e.target.value)}
                                />
                                {message && <p className="success">{message}</p>}
                                {error && <p className="error">{error}</p>}
                                <div className='buttonsModal'>
                                    <button disabled={processing} type="submit" className='saveChangesPartners'>Создать тариф</button>
                                    <button disabled={processing} type="button" className='cancelPartners' onClick={closeCreateModal}>Отмена</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )
            }

            {isEditModalOpen && (
                <div className="modalOverlay">
                    <div className="modalPartners">
                        <form onSubmit={handleEditTariff}>
                            <div className="modalTop">
                                <h3>Редактировать тариф</h3>

                                <button
                                    type="button"
                                    onClick={closeEditModal}
                                ></button>
                            </div>

                            <input
                                type="text"
                                required
                                placeholder="Название тарифа"
                                value={editedTariffName}
                                onChange={(e) =>
                                    setEditedTariffName(e.target.value)
                                }
                            />

                            {message && (
                                <p className="success">{message}</p>
                            )}

                            {error && (
                                <p className="error">{error}</p>
                            )}

                            <div className="buttonsModal">
                                <button
                                    disabled={processing}
                                    type="submit"
                                    className="saveChangesPartners"
                                >
                                    Сохранить
                                </button>

                                <button
                                    disabled={processing}
                                    type="button"
                                    className="cancelPartners"
                                    onClick={closeEditModal}
                                >
                                    Отмена
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}